import React from 'react'
import Paper from 'material-ui/Paper';
import AllRooms from '../../../../components/rooms/AllRooms'

import { rooms as ROLES_CONFIG } from '../../../../config/roles';

export default class Rooms extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (

      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.roomList.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3} style={{ overflowX: "visible" }}>
                <AllRooms />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/rooms/Rooms.js